export const stacks = [
  {
    slug: 'sleep-stack',
    name: 'The Sleep Stack',
    sslProduct: 'PyjamaTime',
    productCode: 'NTB-60',
    badge: 'Men & Women',
    for: 'A food supplement · 60 capsules — 30-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'monthly',
    capsules: '60 capsules — 30-day supply',
    stripeOneOff: 'https://buy.stripe.com/3cI9AU7MIg50bOB4tw73G0V',
    stripeSubscription: 'https://buy.stripe.com/7sYfZi1okf0W05T9NQ73G15',
    description: 'PyjamaTime is a food supplement made in the UK under GMP standards. Each pack contains 60 capsules, a 30-day supply. Available as a one-off purchase or on subscription, renewing monthly, with free UK delivery; cancel any time.',
    ingredients: 'Montmorency tart cherry extract, Ashwagandha root extract (KSM-66), Passionflower extract, German chamomile extract, Lemon balm extract, Lavender extract, L-Taurine, L-Tyrosine, Niacin (B3), Pantothenic acid (B5), Vitamin B6, Biotin, Magnesium',
    dosage: 'Take 2 capsules 30–60 minutes before bed with water. Do not exceed recommended dose.',
    suitable: 'Men and women.',
    color: '#141b28',
  },
  {
    slug: 'focus-stack',
    name: 'The Focus Stack',
    sslProduct: 'Turbo Brain',
    productCode: 'TBN60',
    badge: 'Men & Women',
    for: 'A food supplement · 60 capsules — 30-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'monthly',
    capsules: '60 capsules — 30-day supply',
    stripeOneOff: 'https://buy.stripe.com/14A14o5EA5qmbOB8JM73G0W',
    stripeSubscription: 'https://buy.stripe.com/6oU6oIeb62ea8Cp5xA73G16',
    description: 'Turbo Brain is a food supplement made in the UK under GMP standards. Each pack contains 60 capsules, a 30-day supply. Available as a one-off purchase or on subscription, renewing monthly, with free UK delivery; cancel any time.',
    ingredients: 'Korean Panax ginseng, Guarana, Bacopa monnieri, Cinnamon, Ginkgo leaf, Turmeric root (95% curcuminoids), Green tea leaf, Caffeine, L-Theanine, L-Tyrosine, N-Acetyl L-Carnitine, Rosemary leaf, DHA, Choline, Phosphatidylcholine, Phosphatidylserine, Silica (bamboo), Black pepper, Zinc, Vitamin B12, Niacin (B3), Pantothenic acid (B5), Folic acid, Iodine',
    dosage: 'Take 2 capsules daily with food, preferably in the morning.',
    suitable: 'Men and women. Contains caffeine.',
    color: '#131e1c',
  },
  {
    slug: 'balance-stack',
    name: 'The Balance Stack',
    sslProduct: 'MENOstage',
    productCode: 'SN015',
    badge: 'Women',
    for: 'A food supplement · 60 capsules — 30-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'monthly',
    capsules: '60 capsules — 30-day supply',
    stripeOneOff: 'https://buy.stripe.com/8x214oaYUdWS4m99NQ73G12',
    stripeSubscription: 'https://buy.stripe.com/fZu6oIc2Y3ieg4Re4673G13',
    description: 'MENOstage is a food supplement made in the UK under GMP standards. Each pack contains 60 capsules, a 30-day supply. Available as a one-off purchase or on subscription, renewing monthly, with free UK delivery; cancel any time.',
    ingredients: 'Red clover extract, Wild yam extract, Sage leaf extract, Soya isoflavones (40%), Siberian ginseng extract, Schizandra berry extract, Hops extract, Alfalfa extract, Pfaffia powder, Atriplex halimus, Kelp, Vitamin B6, Zinc citrate',
    dosage: 'Take 2 capsules daily with food.',
    suitable: 'Women. Not suitable during pregnancy or breastfeeding.',
    color: '#221319',
  },
  {
    slug: 'energy-stack',
    name: 'The Energy Stack',
    sslProduct: 'CherryBeet',
    productCode: 'BRMC60',
    badge: 'Men & Women',
    for: 'A food supplement · 60 capsules — 30-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'monthly',
    capsules: '60 capsules — 30-day supply',
    stripeOneOff: 'https://buy.stripe.com/5kQ9AU9UQ2eaf0N9NQ73G0X',
    stripeSubscription: 'https://buy.stripe.com/8x28wQ0kg6uq5qde4673G17',
    description: 'CherryBeet is a food supplement made in the UK under GMP standards. Each pack contains 60 capsules, a 30-day supply. Available as a one-off purchase or on subscription, renewing monthly, with free UK delivery; cancel any time.',
    ingredients: 'Beetroot powder and extract 10:1, Montmorency cherry powder and extract 10:1 (4500mg equivalent), Turmeric extract (95% curcumin), Vitamin B6, Black pepper powder',
    dosage: 'Take 2 capsules daily with food.',
    suitable: 'Men and women.',
    color: '#2C2218',
  },
  {
    slug: 'mood-stack',
    name: 'The Mood Stack',
    sslProduct: 'Maca Complex Plus',
    productCode: 'MACA90',
    badge: 'Men & Women',
    for: 'A food supplement · 90 capsules — 45-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'every 45 days',
    capsules: '90 capsules — 45-day supply',
    stripeOneOff: 'https://buy.stripe.com/3cI8wQ0kg8CyaKxf8a73G0Y',
    stripeSubscription: 'https://buy.stripe.com/5kQ4gA7MIbOK3i57FI73G18',
    description: 'Maca Complex Plus is a food supplement made in the UK under GMP standards. Each pack contains 90 capsules, a 45-day supply. Available as a one-off purchase or on subscription, renewing every 45 days, with free UK delivery; cancel any time.',
    ingredients: 'Maca root extract (3000mg equivalent), Ginkgo biloba extract, Panax ginseng extract, Ginger root extract, L-Arginine, Damiana leaf extract, Organic black pepper (piperine), Zinc',
    dosage: 'Take 2 capsules daily with food. Each bottle provides a 45-day supply.',
    suitable: 'Men and women.',
    color: '#1e1525',
  },
  {
    slug: 'testosterone-support',
    name: 'Testosterone Support',
    sslProduct: 'Ashwagandha Botanical Complex',
    productCode: 'ASWG90',
    badge: 'Men',
    for: 'A food supplement · 90 capsules — 45-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'every 45 days',
    capsules: '90 capsules — 45-day supply',
    stripeOneOff: 'https://buy.stripe.com/4gM00k0kgcSO2e1gce73G0Z',
    stripeSubscription: 'https://buy.stripe.com/5kQcN6gje2ea9GtbVY73G19',
    description: 'Ashwagandha Botanical Complex is a food supplement made in the UK under GMP standards. Each pack contains 90 capsules, a 45-day supply. Available as a one-off purchase or on subscription, renewing every 45 days, with free UK delivery; cancel any time.',
    ingredients: 'Ashwagandha root extract KSM-66, Panax ginseng extract, Reishi mushroom extract, Cordyceps mushroom extract, Pantothenic acid (B5), Niacin (B3), Vitamin B6, Vitamin B12',
    dosage: 'Take 2 capsules daily with food, preferably in the morning. Each bottle provides a 45-day supply.',
    suitable: 'Men. Not suitable if you have thyroid, liver or cardiac conditions without GP advice.',
    color: '#121a14',
  },
  {
    slug: 'hormone-foundation',
    name: 'Hormone Foundation',
    sslProduct: 'Magnesium 3 Complex',
    productCode: '3MG90',
    badge: 'Men & Women 50s+',
    for: 'A food supplement · 90 capsules — 45-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'every 45 days',
    capsules: '90 capsules — 45-day supply',
    stripeOneOff: 'https://buy.stripe.com/3cI9AUgjeg502e1bVY73G10',
    stripeSubscription: 'https://buy.stripe.com/cNi28saYU8CybOB1hk73G1a',
    description: 'Magnesium 3 Complex is a food supplement made in the UK under GMP standards. Each pack contains 90 capsules, a 45-day supply. Available as a one-off purchase or on subscription, renewing every 45 days, with free UK delivery; cancel any time.',
    ingredients: 'Magnesium glycinate, Magnesium malate, Magnesium taurate, Vitamin B6, Zinc',
    dosage: 'Take 2 capsules daily with food. Each bottle provides a 45-day supply.',
    suitable: 'Men and women.',
    color: '#3d3528',
  },
  {
    slug: 'thyroid-stack',
    name: 'The Thyroid Stack',
    sslProduct: 'Sea & Soil',
    productCode: 'OSS-100',
    badge: 'Men & Women',
    for: 'A food supplement · 100 capsules — 50-day supply',
    price: 27.99,
    subscriptionPrice: 22.99,
    billingPeriod: 'every 50 days',
    capsules: '100 capsules — 50-day supply',
    stripeOneOff: 'https://buy.stripe.com/7sY6oI5EA0626uh5xA73G11',
    stripeSubscription: 'https://buy.stripe.com/9B68wQd728Cy7yl5xA73G14',
    description: 'Sea & Soil is a food supplement made in the UK under GMP standards. Each pack contains 100 capsules, a 50-day supply. Available as a one-off purchase or on subscription, renewing every 50 days, with free UK delivery; cancel any time.',
    ingredients: 'Seagreens Ascophyllum nodosum (certified organic), Seagreens Fucus vesiculosus (certified organic), Artichoke extract, Chlorella, Green tea extract, Spirulina, Alfalfa, Cayenne pepper',
    dosage: 'Take 2 capsules daily with food. Each bottle provides a 50-day supply.',
    suitable: 'Men and women. If you have, or think you may have, a thyroid condition, speak to your GP before use.',
    color: '#1a1812',
  },
];
